import { render, staticRenderFns } from "./ShangChenWuLiu.vue?vue&type=template&id=216df1f0&scoped=true&"
import script from "./ShangChenWuLiu.vue?vue&type=script&lang=js&"
export * from "./ShangChenWuLiu.vue?vue&type=script&lang=js&"
import style0 from "./ShangChenWuLiu.vue?vue&type=style&index=0&id=216df1f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216df1f0",
  null
  
)

export default component.exports